<template>
  <div class="container" :class="type">
    <lessonIframe
      :id="id"
      @back="back"
      :type="type"
      ref="lessonIframe"
      @runStep="runStep" />
  </div>
</template>
<script>

import lessonIframe from '@/components/lessonIframe'

export default {
  components: {
    lessonIframe
  },
  data() {
    return {
      type: '',
      iframeUrl: '',
      isRunStep: false // 编辑器练习是否运行
    }
  },
  methods: {
    back(check = true) {
      console.log(check)
      this.$router.back()
    },
    runStep(data) {
      this.isRunStep = data.isRunStep
    }
  },
  mounted() {
    this.type = this.$route.query.type
    this.id = this.$route.query.id || ''
  }
}
</script>

<style lang="less" scoped>
.container{
  width: 100%;
  height: 100%;
  position: relative;
}
.editor{
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 100;
}
.back{
  position: absolute;
  left: 22px;
  top: 24px;
  cursor: pointer;
  width: 30px;
  border-radius: 4px;
  background: #fff;
}
</style>
